module.exports = __webpack_public_path__ + "static/media/iconCanvas04.c049cc24.svg";